const SET_DEFAULT_CREDENTIALS = 'SET_DEFAULT_CREDENTIALS';
const CLEAR_DEFAULT_CREDENTIALS = 'CLEAR_DEFAULT_CREDENTIALS';

export const setDefaultCredentials = (account, credentialType) => ({type: SET_DEFAULT_CREDENTIALS, account, credentialType});
export const clearDefaultCredentials = () => ({type: CLEAR_DEFAULT_CREDENTIALS});

// Reducer
const _defaultState = () => ({
    defaultCredentialsParams: {
        account:        undefined,
        credentialType: undefined
    }
});


export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case SET_DEFAULT_CREDENTIALS:
        return {
            ...state,
            defaultCredentialsParams: {
                account:        action.account,
                credentialType: action.credentialType
            }
        };
    case CLEAR_DEFAULT_CREDENTIALS:
        return {
            ...state,
            defaultCredentialsParams: {
                account:        undefined,
                credentialType: undefined
            }
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/credentials.js